import React from 'react'
import { useTranslation } from 'react-i18next'
import { CheckCircle2, CircleDot, AlertTriangle, XCircle } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { scheduleHealthVariant } from '@/lib/status-variants'
import type { ScheduleHealth } from '../lib/constants'

const ICONS = { COMPLETED: CheckCircle2, ON_TRACK: CircleDot, AT_RISK: AlertTriangle, DELAYED: XCircle } as const

const HealthBadge: React.FC<{ health: ScheduleHealth; iconOnly?: boolean; className?: string }> = ({ health, iconOnly, className }) => {
  const { t } = useTranslation()
  const Icon = ICONS[health]
  const badge = (
    <Badge variant={scheduleHealthVariant(health)} className={className}>
      <Icon className="h-3 w-3" />
      {!iconOnly && <span className="ml-1">{t(`Schedule_health_${health}`)}</span>}
    </Badge>
  )
  if (!iconOnly) return badge
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild><span className="inline-flex">{badge}</span></TooltipTrigger>
        <TooltipContent>{t(`Schedule_health_${health}`)}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
export default HealthBadge
